<template>
  <div class="columns cards-container mt-5">
    <HealthInsuranceExplanationCard
      v-for="(card, index) in cards"
      :key="index"
      :icon-url="card.iconUrl"
      :has-button="card.hasButton"
      :index="index"
      class="explanation-card"
      :health-insurance="healthInsurance"
    />
  </div>
</template>

<script>
import HealthInsuranceExplanationCard from "~/components/healthInsurance/HealthInsuranceExplanationCard.vue"
import HealthInsurances from "~/models/healthInsurances.js"

export default {
  name: "AokPlusExplanationCardsContainer",
  components: { HealthInsuranceExplanationCard },
  props: {
    healthInsurance: {
      type: String,
      default: HealthInsurances.aokPlus,
    },
  },
  computed: {
    cards() {
      const defaultCards = [
        {
          iconUrl: "message-icon.svg",
        },
        {
          iconUrl: "lightning-icon.svg",
        },
        {
          iconUrl: "bill-icon.svg",
          hasButton: this.healthInsurance === HealthInsurances.aokRps,
        },
        {
          iconUrl: "happy-icon.svg",
        },
      ]
      // remove last card, in case of Mobil KK and AOK Plus
      if (this.healthInsurance === HealthInsurances.mobil || this.healthInsurance === HealthInsurances.aokPlus) {
        defaultCards.pop()
      }
      return defaultCards
    },
  },
}
</script>

<style scoped lang="scss">
.cards-container {
  display: flex;
  flex-direction: row;
  gap: 1rem;
  flex-wrap: wrap;
  align-content: center;
  justify-content: center;
  padding: 0 1rem;

  div {
    width: 70%;
  }

  @media screen and (max-width: $tablet) {
    flex-direction: row;
    div {
      max-width: 320px;
    }
  }

  @media screen and (max-width: $mobile) {
    flex-direction: column;
    div {
      width: 100%;
      max-width: 100%;
    }
  }
}
</style>
